module.exports = __webpack_public_path__ + "static/media/left-neighbour.6f911185.svg";